import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
@Injectable({ providedIn: 'root' })
export class NotificationService {
    
    private cartSource = new BehaviorSubject(0);
    cartMessage = this.cartSource.asObservable();
  
    constructor(private http: HttpClient) { }
  
    changeMessage(cartNoti: number) {
      this.cartSource.next(cartNoti)
    }

    countNotification(){
      return this.http.get<any>(`${environment.apiUrl}/notification/notification?status=0`)
    }

    getNotification(perPage:number, page:number){
      return this.http.get<any>(`${environment.apiUrl}/notification/notification?perPage=${perPage}&page=${page}`)
    }

    getAllNotification(perPage:number, page:number){
      return this.http.get<any>(`${environment.apiUrl}/notification/notification/all?perPage=${perPage}&page=${page}`)
    }

    postNotification(data:any){
      return this.http.post<any>(`${environment.apiUrl}/notification/notification`, data)
    }

    clickNotification(id:string){
      var data = {
          "status": 1
      }
      return this.http.patch<any>(`${environment.apiUrl}/notification/notification/${id}`, data) ;
    }

    deleteNotication(id:string){
      return this.http.delete<any>(`${environment.apiUrl}/notification/notification/${id}`) ;
    }

}